import React from 'react';
import PropTypes from 'prop-types';
import { CardImg } from 'reactstrap';
var RobotDeliveryPromoBanner = function (props) {
    if (props.isTakeout || !props.canOrderRobotDelivery) {
        return null;
    }
    return (React.createElement("div", { className: "d-flex flex-row flex-wrap col-12" },
        React.createElement("div", { className: "p-0 col-12 col-md-5" },
            React.createElement(CardImg, { width: "100%", src: "https://deliverycouple.com/images/mateuszv1.jpg", className: "mb-3 mb-md-0" })),
        React.createElement("div", { className: "col-12 col-md-7 px-0 pl-md-3" },
            React.createElement("p", null, "Hej, nazywam si\u0119 Mateusz i jestem pierwszym w Polsce robotem do dostarczenia przesy\u0142ek."),
            React.createElement("div", { className: "mb-0" },
                "Je\u017Celi chcesz, abym przywi\u00F3z\u0142 Twoje zam\u00F3wienie - wybierz opcj\u0119",
                React.createElement("div", null,
                    React.createElement("i", { className: "text-primary mr-1" }, "Dostawa robotem"),
                    " powy\u017Cej.")))));
};
RobotDeliveryPromoBanner.propTypes = {
    canOrderRobotDelivery: PropTypes.bool.isRequired,
    isTakeout: PropTypes.bool.isRequired,
};
RobotDeliveryPromoBanner.displayName = 'RobotDeliveryPromoBanner';
export default React.memo(RobotDeliveryPromoBanner);
